import { StorageDriver } from 'helpers/storage';

export const STORAGE_AUTH_TOKEN_KEY = 'authorization';
export const STORAGE_PROVIDER_KEY = 'storageProvider';

export const storageDriver = new StorageDriver(STORAGE_AUTH_TOKEN_KEY, STORAGE_PROVIDER_KEY);
